;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Controller = APP.module('Controller');
	var Router     = APP.module('Router');
	var Model      = APP.module('Model');
	var View       = APP.module('View');
	var Layout     = APP.module('Layout');
	var Collection = APP.module('Collection');

	Controller.Registration = Marionette.Controller.extend({
		initialize: function(){
			this.user              = APP.module('instance').user;
			this.formBuilderData   = new Model.RegistrationFormBuild().toJSON();
			this.listenTo(APP.vent, 'register:next:step', this.checkForNextStep);
            this.listenTo(APP.vent, 'registration_auto_fb_connect', this.registrationAutoFbConnect);
            if (CONFIG.IS_MULTY_LANG) {
                this.clearStorageForm();
            }
        },
        start: function (step) {


			var step_layout = this.formBuilderData.steps_layouts[step],
				footer =  this.formBuilderData.footer_content_view ? this.formBuilderData.footer_content_view : false;

			this.view = new Layout[step_layout]();

			APP.vent.trigger('preloader:hide');
			APP.main.show(this.view);

			footer && APP.footer.show(new View[footer]());
		},
        clearStorageForm: function () {
            if (APP.getJStorage('registrationUser') && typeof APP.getJStorage('registrationUser') !='undefined'
				&& APP.getJStorage('registrationUser').form && typeof APP.getJStorage('registrationUser').form != 'undefined'
                && APP.getJStorage('registrationUser').form.form_attrs && typeof APP.getJStorage('registrationUser').form.form_attrs !='undefined') {
                APP.delJStorage('registrationUser').form.form_attrs
            }
        }
        ,
		registrationAutoFbConnect: function(){
			var cached_user_data = APP.getJStorage('registrationUser');

			if(!cached_user_data){

				cached_user_data = {
					fb : {
						auto_connect: true
					}
				}
			}
			else {
				cached_user_data.fb.auto_connect = true;
			}

			APP.setJStorage('registrationUser', cached_user_data, 3600000);

			return this;
		},
		checkForNextStep: function(data) {

			APP.vent.trigger('preloader:show');

			var models_data = {
					fb:   data.fb.toJSON(),
					form: data.form.toJSON()
				},
				is_step_complete = _.indexOf(['registrationStep1', 'registrationStep2', 'completeRegistration'], data.step) !== -1;

			APP.setJStorage('registrationUser', models_data);

			if(is_step_complete) {
				this[data.step](models_data);
			}
			else {
				this.registrationNotCompleted(models_data, data.step);
			}
		},

		registrationStep1: function(models) {

			Backbone.history.navigate('registration/step_1');
			// Build layout
			this.start('first_step');

			var model = this.getModel(models);

			//Show widgets
			var sidebar = new Layout.Sidebar({
				widgets_list: this.formBuilderData.step1_side_bar_widgets
			});

			//Add Views to regions
			this.addViewToRegions('RegistrationStep1', 'first_step', sidebar, model);
		},

		registrationStep2: function(models) {
			Backbone.history.navigate('registration/step_2');
			// Build layout
			this.start('second_step');

			var model = this.getModel(models);

			//Show widgets
			var sidebar = new Layout.Sidebar({
				widgets_list: this.formBuilderData.step2_side_bar_widgets
			});

			//Add Views to regions
			this.addViewToRegions('RegistrationStep2', 'second_step', sidebar, model);
			this.setGa()
		},


		registrationSSO: function(models) {
			// Build layout
			this.start('second_step');

			var model = this.getModel(models);

			//Show widgets
			var sidebar = new Layout.Sidebar({
				widgets_list: this.formBuilderData.step2_side_bar_widgets
			});

			//Add Views to regions
			this.addViewToRegions('RegistrationStep2', 'second_step', sidebar, model);
			this.setGa()
		},

		completeRegistration: function(models_data){
			// console.log(9191, "old registration finished");
			// console.log(9191, models_data.form);
			// const CODE_VERIFIER = localStorage.getItem("code_verifier");
            // const REDIRECT_URI = localStorage.getItem("redirect_uri");
            // const CODE = localStorage.getItem("code");
            // models_data.form.code = CODE;
            // models_data.form.redirect_url = REDIRECT_URI;
            // models_data.form.code_verifier = CODE_VERIFIER;
			// models_data.form.sponsor_opt_in = models_data.form.terms;
			// var fb_token = models_data.fb.token ? models_data.fb.token : false,
			// 	create_user = this.user.createSSO(_.omit(models_data.form, _.isUndefined), fb_token);

			var fb_token = models_data.fb.token ? models_data.fb.token : false,
				create_user = this.user.create(_.omit(models_data.form, _.isUndefined), fb_token);

			$.when.call(null, create_user).done(function(response){
				if (response.errors.length) {
					APP.vent.trigger('user:register:error', response.errors);
				}
				else {
					APP.vent.trigger('user:register', { user: response.result.user, session_id: response.result.session_id ,token: fb_token });
					
				}
				
			});

		},

		registrationNotCompleted: function(models_data, step){
			var fb_token = models_data.fb.token ? models_data.fb.token : false,
				create_user = this.user.create(_.omit(models_data.form, _.isUndefined), fb_token);

			$.when.call(null, create_user).done(_.bind(function(response){
				if (response.errors.length) {
					APP.vent.trigger('user:register:error', response.errors);
				}
				else {
					APP.vent.trigger('user:register:not_completed', {  user: response.result.user, session_id: response.result.session_id, token: fb_token });
					this[step]();
					this.saveIfTeamIsApply();
				}
			}, this));
		},

		saveIfTeamIsApply: function(){
			var peekedTeem = APP.getJStorage('user_lineup'),
				teamBuilderModel = new Model.SuperRugbyClassicTeam();
			if(!peekedTeem){
				return;
			}
			$.when.call(null,teamBuilderModel.setApiUrl('classic_team/save').saveTeam(peekedTeem)).then(function(response){
				APP.setJStorage('user_lineup', null)
			})
			
		},

		registerForGame: function(){
			console.log(1111);
			// Build layout
			this.start('register_for_game');
			//Show widgets
			var sidebar = new Layout.Sidebar({
				widgets_list: this.formBuilderData.step2_side_bar_widgets
			});

			//Add Views to regions
			this.addViewToRegions('RegisterForGame', 'register_for_game', sidebar);
		},

		registerRecover: function(){
			// Build layout
			this.start('register_recover');
			//Show widgets
			var sidebar = new Layout.Sidebar({
				widgets_list: this.formBuilderData.step2_side_bar_widgets
			});

			//Add Views to regions
			this.addViewToRegions('RegisterRecover', 'register_recover', sidebar);
		},

		registrationCreateLeague: function(){
			Backbone.history.navigate('registration/create_league');
			this.start('join_create_league');

			var sidebar = new Layout.Sidebar({
				widgets_list: this.formBuilderData.step2_side_bar_widgets
			});

			this.addViewToRegions('JoinCreateLeague', 'join_create_league', sidebar);
			this.setGa();
		},

		registrationPeakTeam: function(){
			Backbone.history.navigate('registration/pick_team');
		},

		addViewToRegions: function(main_view, form_view, sidebar, models){
			var stepView = new View[main_view](this.generateRegistrationForm(models, this.formBuilderData.steps_views[form_view]));
			this.view.main.show(stepView);
			if(sidebar.getOption('widgets_list').length){
				//if using template with Sidebar
				if (this.view.aside) this.view.aside.show(sidebar);
			}
		},

		generateRegistrationForm: function(model, template) {
			var registerForm,
				fbModel,
				cached_user = APP.getJStorage('registrationUser');

			if(model){
				registerForm = new Model.Registration(model.form);
				fbModel = new Model.FacebookConnect(model.fb);
			}
			else {
				registerForm = new Model.Registration();
				fbModel = new Model.FacebookConnect();
			}

			var fb_auto_connect = cached_user && cached_user.fb ? cached_user.fb.auto_connect : false;
			fbModel.set('auto_connect', fb_auto_connect);

			return {
				formTemplate: template,
				viewData: this.setDataForStep(registerForm, fbModel)
			};
		},

		getModel: function(model){
			return model || APP.getJStorage('registrationUser');
		},

		setDataForStep: function(model , fb_model){
				var leagueModel = this.formBuilderData.league_model ? new Model[this.formBuilderData.league_model]() : false,
					leagueCollection = this.formBuilderData.league_collection ? new Collection[this.formBuilderData.league_collection]() : false,

				extend_options = _.extend({}, this.formBuilderData,{
					model:                       model,
					facebookModel:               fb_model,
					user:                        this.user,
					countries:                   new Collection.Countries(),
					states:                      new Collection.States(),
					squads:                      new Collection.Squads(),
					league_model:                leagueModel,
					league_collection:           leagueCollection}) ;
			return extend_options;
		},

		followToFirstStep: function() {

			Backbone.history.navigate('/');
			Backbone.history.navigate(this.formBuilderData.first_step_url, { trigger: true});
		},

		setGa: function(){
			var url = Backbone.history.getFragment();
			if (!/^\//.test(url)) {
				url = '/' + url;
			}

			if(CONFIG.GOOGLE_ACCOUNT_ID) {

				ga('send', {
					'hitType': 'pageview',
					'page':    url
				});
			}

		}
	});

	
	APP.on('start', function() {
		new Router.Registration({
			controller:  new Controller.Registration()
		});
	});

}(window, APP, Backbone, Marionette, $, _));
